export const API_PROXY = "https://api.drugie-knigi.ru/api/v1";
